import { plainToInstance } from 'class-transformer';
import { AbstractNetworkService } from 'core/data/remote/AbstractNetworkService';
import { NetWorkService } from 'core/data/remote/NetworkService';
import { ResponseResult } from 'core/models/ResponseResult';
import { AbstractDryCleaningRemoteDataSource } from 'features/dryCleaning/data/remote/Abstract_dry_cleaning_remote_data_source';
import { SewingModel } from 'features/sewing/data/models/SewingModel';

export class DryCleaningRemoteDataSource implements AbstractDryCleaningRemoteDataSource {
  netowkService: AbstractNetworkService = new NetWorkService();
  async getDryCleaning(): Promise<ResponseResult> {
    try {
      const response = await this.netowkService.get('/dry_cleaning_get');
      response.data = this.convertFromJsonToTableModel(response.data);
      return response;
    } catch (error) {
      return new ResponseResult({
        code: '0',
        timeStamp: new Date().toISOString(),
        success: false,
        message: 'Unknown Error - An undefined error occured',
        data: null,
      });
    }
  }

  convertFromJsonToTableModel(data: any): SewingModel[] {
    return (data as []).flatMap((e) => plainToInstance(SewingModel, e));
  }
}
